/**
 * Mobile Header Hide on Scroll
 * Hides header and announcement bar when scrolling down on mobile,
 * shows them again when scrolling back up
 */

(function() {
  'use strict';

  function init() {
    // Only run on mobile devices
    if (window.innerWidth > 740) {
      return;
    }

    const headerSection = document.querySelector('.shopify-section--header');
    const announcementBar = document.querySelector('.shopify-section--announcement-bar');
    const isCollectionPage = document.body.classList.contains('template-collection') || document.body.classList.contains('template-search');
    const mobileFacetToolbar = isCollectionPage ? document.getElementById('mobile-facet-toolbar') : null;
    
    if (!headerSection && !announcementBar) {
      return;
    }

    let lastScrollY = window.scrollY;
    let isScrollingDown = false;
    let ticking = false;

    function updateHeaderVisibility() {
      const currentScrollY = window.scrollY;
      const scrollDifference = currentScrollY - lastScrollY;
      
      // Only hide/show if scrolled more than 5px to avoid jitter
      if (Math.abs(scrollDifference) < 5) {
        ticking = false;
        return;
      }

      // Scrolling down
      if (scrollDifference > 0 && currentScrollY > 50) {
        if (!isScrollingDown) {
          isScrollingDown = true;
          if (announcementBar) {
            announcementBar.style.transform = 'translateY(-100%)';
            announcementBar.style.transition = 'transform 0.3s ease-out';
          }
          if (headerSection) {
            headerSection.style.transform = 'translateY(-200%)';
            headerSection.style.transition = 'transform 0.3s ease-out';
          }
          // On collection pages, set mobile-facet-toolbar to top: 0
          if (mobileFacetToolbar) {
            mobileFacetToolbar.classList.add('mobile-toolbar--header-hidden');
          }
        }
      }
      // Scrolling up
      else if (scrollDifference < 0) {
        if (isScrollingDown) {
          isScrollingDown = false;
          if (announcementBar) {
            announcementBar.style.transform = 'translateY(0)';
          }
          if (headerSection) {
            headerSection.style.transform = 'translateY(0)';
          }
          // On collection pages, remove top: 0 from mobile-facet-toolbar
          if (mobileFacetToolbar) {
            mobileFacetToolbar.classList.remove('mobile-toolbar--header-hidden');
          }
        }
      }

      lastScrollY = currentScrollY;
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateHeaderVisibility);
        ticking = true;
      }
    }

    // Listen to scroll events
    window.addEventListener('scroll', onScroll, { passive: true });

    // Reset on resize (in case user rotates device)
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        // If switched to desktop, reset transforms
        if (window.innerWidth > 740) {
          if (announcementBar) {
            announcementBar.style.transform = '';
            announcementBar.style.transition = '';
          }
          if (headerSection) {
            headerSection.style.transform = '';
            headerSection.style.transition = '';
          }
          if (mobileFacetToolbar) {
            mobileFacetToolbar.classList.remove('mobile-toolbar--header-hidden');
          }
          isScrollingDown = false;
        }
      }, 100);
    }, { passive: true });
  }

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

